import {formatSequenceDatetime} from '@/modules/patients-therapies/functions'
import {usePatientTherapySequenceContext} from '@/shared/contexts/patient-therapy-sequence-context'
import {Alert} from '@chakra-ui/react'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {hasPassedTherapyDate} from '@cypro/engine/utils'
import {useTranslate} from '@tolgee/react'

// A finished preparation stays processable after its therapy date (CY-325); this names the planned slot so staff can judge it.
export function usePastTherapyDateWarning(sequence: PatientTherapySequence): string | null {
  const {t} = useTranslate('common')
  if (!hasPassedTherapyDate(sequence)) return null
  return t('therapy_sequence_planned_for', 'Planned for {datetime}', {datetime: formatSequenceDatetime(sequence)})
}

export function PastTherapyDateAlert() {
  const {t} = useTranslate('common')
  const {sequence} = usePatientTherapySequenceContext()
  const warning = usePastTherapyDateWarning(sequence)
  if (!warning) return null

  return (
    <Alert.Root size="sm" status="warning" borderRadius="l2" marginBottom="4">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title fontSize="xs">
          {t('therapy_sequence_date_passed_warning', 'The therapy date has passed')}
        </Alert.Title>
        <Alert.Description fontSize="xs">{warning}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}
